import { ReportDepCell } from './ReportDepCell';

export default ReportDepCell;
